import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Body } from '@edreamsodigeo/prisma-design-system';
import { BrandIcon } from '../BrandIcon';

export const PrimePopOver = ({ text }) => {
  return (
    <Flex
      alignItems="center"
      padding={'2'}
      backgroundColor={'primary.90'}
      borderRadius={'2'}
      position="relative"
      marginBottom={'2'}
    >
      <Box
        position="absolute"
        width="14px"
        height="14px"
        backgroundColor={'primary.90'}
        style={{
          top: 'calc(100% - 8px)',
          left: '20px',
          transform: 'rotate(45deg)',
        }}
      />
      <Box width={'24px'} height={'24px'}>
        <BrandIcon size="medium" color="secondary.50" newColor={true} />
      </Box>
      <Box paddingLeft={'1x_small'}>
        <Body color={'neutral.0'} type="small" weight={'medium'}>
          {text}
        </Body>
      </Box>
    </Flex>
  );
};

PrimePopOver.propTypes = {
  text: PropTypes.node,
};
